import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { InstallPrompt } from "../ui/install-prompt";
import { useLocation } from "wouter";

interface LayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

export function Layout({ children, hideFooter = false }: LayoutProps) {
  const [location] = useLocation();
  // Only apply left margin if sidebar is visible (on dashboard/role routes)
  const hasSidebar = location.startsWith("/manager") || location.startsWith("/owner") || location.startsWith("/agent") || location.startsWith("/admin") || location.startsWith("/settings") || location.startsWith("/stripe-connect");
  return (
    <div className={`flex min-h-screen ${hasSidebar ? 'md:ml-64' : ''}`}>
      <div className="flex flex-col flex-1 min-h-screen">
        <Header />
        <main className="flex-1">{children}</main>
        {!hideFooter && <Footer />}
        <InstallPrompt />
      </div>
    </div>
  );
}